import { Box, Divider, Stack, Typography } from "@mui/material";
import React from "react";
import { lookingForHostsData } from "../../assets/data";
import { colors, theme } from "../../theme/theme";
import {
  ChatOutlined,
  HomeOutlined,
  InsertInvitationOutlined,
  PersonOutlineOutlined,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const LookingForHosts = ({ allGroups = [] }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ my: 4 }}>
      <Stack
        direction={"row"}
        sx={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <Typography sx={theme.subHeading}>
          Groups ({allGroups?.length})
        </Typography>
        <Typography
          sx={{
            color: colors.secondary,
            fontFamily: "Mulish-Medium",
            fontSize: "14px",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => {
            navigate("/groups");
          }}
        >
          See All
        </Typography>
      </Stack>

      <Box
        sx={{
          backgroundColor: "transparent",
          border: `1px solid ${colors.secondary}`,
          borderRadius: "8px",
          p: 1.5,
          mt: 1,
        }}
      >
        {allGroups?.map((item, index) => (
          <React.Fragment key={index}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 1.5,
              }}
            >
              <img
                src={item?.image_url}
                alt="avatar1"
                style={{
                  height: "40px",
                  width: "40px",
                  borderRadius: "50%",
                }}
              />
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mulish-SemiBold",
                      fontSize: "14px",
                      color: colors.secondary,
                    }}
                  >
                    {item?.title}
                  </Typography>
                  <Typography
                    sx={{
                      color: colors.secondary,
                      fontFamily: "Mulish-Medium",
                      fontSize: "12px",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    @{item?.user?.firstName + "" + item?.user?.lastName}
                  </Typography>
                </Stack>

                {/* <Typography
                  sx={{
                    color: "#fff",
                    fontSize: "14px",
                    fontFamily: "Mulish-Regular",
                    fontWeight: 300,
                  }}
                >
                  Joining Points: {item.points_of_joining}
                </Typography> */}

                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  mt={1}
                >
                  <Stack direction={"row"} alignItems={"center"} gap={0.5}>
                    <ChatOutlined
                      sx={{ color: colors.secondary, fontSize: "18px" }}
                    />
                    <Typography
                      sx={{
                        color: "#fff",
                        fontFamily: "Mulish-Regular",
                        fontSize: "12px",
                      }}
                    >
                      {item?.groupDiscussionsCount} discussions
                    </Typography>
                  </Stack>
                  {/* <Stack direction={"row"} alignItems={"center"} gap={0.5}>
                    <InsertInvitationOutlined
                      sx={{ color: colors.secondary, fontSize: "18px" }}
                    />
                    <Typography
                      sx={{
                        color: "#fff",
                        fontFamily: "Mulish-Regular",
                        fontSize: "12px",
                      }}
                    >
                      {item.dateRange}
                    </Typography>
                  </Stack> */}
                  <Stack direction={"row"} alignItems={"center"} gap={0.5}>
                    <PersonOutlineOutlined
                      sx={{ color: colors.secondary, fontSize: "18px" }}
                    />
                    <Typography
                      sx={{
                        color: "#fff",
                        fontFamily: "Mulish-Regular",
                        fontSize: "12px",
                      }}
                    >
                      {item?.memberUserIds?.length} members
                    </Typography>
                  </Stack>
                </Stack>

                <Typography
                  sx={{
                    color: "rgba(255, 255, 255, 0.5)",
                    fontFamily: "Mulish-Medium",
                    fontSize: "12px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 2,
                    maxWidth: "100%",
                    mt: 2,
                  }}
                >
                  {item?.description}
                </Typography>
              </Box>
            </Box>
            {allGroups?.length - 1 !== index && (
              <Divider
                sx={{ my: 1, backgroundColor: "rgba(255,255,255,0.09)" }}
              />
            )}
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
};

export default LookingForHosts;
